/**
 * Convert a 2D array into a CSV string
 */
export function arrayToCsv(data: any[]) {
  return data.map(row =>
    row
      .map(String)  // convert every value to String
      .map((v: string) => v.replaceAll('"', '""'))  // escape double quotes
      .map((v: string) => `"${v}"`)  // quote it
      .join(',')  // comma-separated
  ).join('\r\n');  // rows starting on new lines
}